import {
  ApiOutlined,
  BgColorsOutlined,
  DiffOutlined,
  HddOutlined,
  NodeExpandOutlined,
  PieChartOutlined,
  SettingOutlined,
  UngroupOutlined,
} from "@ant-design/icons";
import { notification } from "antd";
import moment from "moment";
import getWeekOfMonth from "date-fns/getWeekOfMonth";
import React, { useCallback, useState } from "react";
const _ = require("underscore");

const ignoreUrls = [
  { url: "/main/userprofile/settings", title: "My Profile Settings" },
  { url: "/monthly-performance/query-builder", title: "Query Builder" },
]; //use to ignore some menu that is not in header and sidebar

export const getMenu = (url) => {
  try {
    const exist = _.where(ignoreUrls, { url: url });
    if (exist.length) {
      return _.first(exist).title;
    }
    //return url;

    const appMenu = window.appMenu;
    if (!appMenu?.length) return "";
    const sm = _.first(
      _.where(_.flatten(_.pluck(appMenu, "subMenus")), { url: url })
    );
    let subMenu;

    if (sm) {
      subMenu = sm.name;

      const menuName = _.first(
        _.where(window.appMenu, { menuId: sm.menuId })
      ).menu;

      if (subMenu === menuName) return ` ${menuName}`;
      return ` ${menuName} | <span style="font-weight:400">${subMenu}</span>`;
    }
  } catch (error) {
    console.log(error);
    notification.error({
      message: "Something went wrong",
      description: "an error occured while loading...",
    });
  }
};

export const selectMenu = (url) => {
  if (!window.appMenu) return;
  const appMenu = window.appMenu;
  if (!appMenu && appMenu.length) return "";
  const sm = _.first(
    _.where(_.flatten(_.pluck(appMenu, "subMenus")), { url: url })
  );

  if (sm) {
    return sm;
  }

  var menu = _.first(_.where(appMenu, { menuUrl: url }));

  return menu;
};

export const canView = (subMenuId, permisions) => {
  const canView = _.first(
    _.where(permisions, { subMenuId: subMenuId })
  ).canView;
  return canView;
};

export const getDuration = (startDate, endDate) => {
  let unit = "months";
  let duration = moment(endDate).diff(moment(startDate), "months");
  unit = duration === 1 ? "month" : "months";
  if (duration > 12) {
    duration = moment(endDate).diff(moment(startDate), "years");
    return {
      duration: duration,
      unit: duration === 1 ? "year" : "years",
    };
  }
  if (duration === 0) {
    duration = moment(endDate).diff(moment(startDate), "weeks");
    unit = duration === 1 ? "week" : "weeks";

    if (duration === 0) {
      duration = moment(endDate).diff(moment(startDate), "days");
      unit = "days";
      if (duration === 0) {
        duration = 1;
        unit = "day";
      }
    }
  }
  return {
    duration: duration,
    unit: unit,
  };
};

export const getPermissions = (url) => {
  //get and  permissions at route level
  let permissions = localStorage.getItem("permissions");
  if (!_.isEmpty(permissions) && permissions !== "undefined") {
    permissions = JSON.parse(localStorage.getItem("permissions"));
    window.userPermissions = permissions;
    const role = _.first(_.where(permissions, { url: url }));
    const exist = _.where(ignoreUrls, { url: url });
    if (exist.length) {
      return {
        canDelete: true,
        canExecute: true,
        canUpdate: true,
        canView: true,
      };
    }
    if (!role) {
      //  window.location = "/login"; Uncomment and remove the return below to activate proper permissions

      return {
        canDelete: "true",
        canExecute: "true",
        canUpdate: "true",
        canView: "true",
      };
    }
    //console.log("user role", role);

    //window.localStorage.setItem("userPermission", JSON.stringify(role));
    const { canDelete, canExecute, canUpdate, canView } = role;

    return {
      canDelete: canDelete,
      canExecute: canExecute,
      canUpdate: canUpdate,
      canView: canView,
    };
  }
};

export const ToolbarSpacer = (props) => {
  const { width } = props;
  return <div style={{ width: `${width}px` }}></div>;
};

export const MenuSeparator = (props) => {
  const css = {
    backgroundColor: "rgb(200, 198, 196)",
    /* marginTop: "4px",
    marginBottom: "4px", */

    width: "1px",
  };
  return <div style={css}></div>;
};

export const getActiveProject = () => {
  let wsProject = sessionStorage.getItem("wsProject");

  if (!_.isEmpty(wsProject) && wsProject !== "undefined") {
    const prj = JSON.parse(wsProject);
    if (prj) {
      return prj;
    }
  }
  return undefined;
};

export const getAntIconEquivalent = (name, collapsed = false) => {
  const IconStyle = {
    fontSize: collapsed ? "24px" : "",
  };

  const icons = [
    {
      key: "solution",
      icon: <DiffOutlined style={IconStyle} />,
    },
    {
      key: "tool",
      icon: <SettingOutlined style={IconStyle} />,
    },
    {
      key: "thunderbolt",
      icon: <ApiOutlined style={IconStyle} />,
    },

    {
      key: "fiscal",
      icon: <UngroupOutlined style={IconStyle} />,
    },
    {
      key: "materialmgt",
      icon: <HddOutlined style={IconStyle} />,
    },
    {
      key: "evacuation",
      icon: (
        <NodeExpandOutlined style={{ fontSize: collapsed ? "30px" : "" }} />
      ),
    },
    {
      key: "maindashboard",
      icon: <PieChartOutlined style={{ fontSize: collapsed ? "30px" : "" }} />,
    },
  ];
  const comp = _.first(_.where(icons, { key: name }));
  if (comp) {
    return comp.icon;
  } else {
    return null;
  }
};

export const getCurrentUser = () =>
  JSON.parse(window.sessionStorage.getItem("currentUser"));
export const setCurrentUser = (data) => {
  window.sessionStorage.setItem("currentUser", JSON.stringify(data));
};

export const setDefaultMenuOpenkey = (data) => {
  window.sessionStorage.setItem("openkey", JSON.stringify(data));
};
export const getDefaultMenuOpenkey = () =>
  window.sessionStorage.getItem("openkey");
export const generateNewAccountRequestCode = (id) => `REQ${2118 + Number(id)}`;

export const getUserPermissions = () =>
  JSON.parse(window.sessionStorage.getItem("permissions"));

export const getUserPermission = () =>
  JSON.parse(window.sessionStorage.getItem("userPermission"));

export const commaFormating = (params) =>
  params?.value ? params?.value.toLocaleString() : params?.value;

export const reactQuiltoolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link"],
  ["clean"], // remove formatting button
];

export const useToggle = (initialState = false) => {
  // Initialize the state
  const [state, setState] = useState(initialState);

  // Define and memorize toggler function in case we pass down the comopnent,
  // This function change the boolean value to it's opposite value
  const toggle = useCallback(() => setState((state) => !state), []);

  return [state, toggle];
};

export class HighlightWeek {
  static getWeeK() {
    return moment().format("W");
  }

  static getWeekDate() {
    var startOfWeek = moment(moment().startOf("week").toDate())
      /*  .add(1, "days") */
      .format("dddd Do MMMM YYYY");
    var endOfWeek = moment(moment().endOf("week").toDate())
      /*  .subtract(1, "days") */
      .format("dddd Do MMMM YYYY");
    return `${startOfWeek}- ${endOfWeek}`;
  }

  static getDateRange(weekNumber) {
    var startOfWeek = moment(moment().week(weekNumber).startOf("week").toDate())
      /* .add(1, "days") */
      .format("dddd Do MMMM YYYY");
    var endOfWeek = moment(moment().week(weekNumber).endOf("week").toDate())
      /*     .subtract(1, "days") */
      .format("dddd Do MMMM YYYY");
    return `${startOfWeek}- ${endOfWeek}`;
  }

  static getDateRangeByYear(weekNumber, year) {
    var startOfWeek = moment(
      moment(`${year}0131`, "YYYYMMDD")
        .week(weekNumber)
        .startOf("week")
        .toDate()
    )
      /* .add(1, "days") */
      .format("ddd Do MMM YYYY");
    var endOfWeek = moment(
      moment(`${year}0131`, "YYYYMMDD").week(weekNumber).endOf("week").toDate()
    )
      /*     .subtract(1, "days") */
      .format("ddd Do MMM YYYY");
    return `${startOfWeek}- ${endOfWeek}`;
  }

  static getWeekMonth() {
    return getWeekOfMonth(new Date());
  }
  static getMonth(weekNumber, year) {
    let month = moment(
      moment(`${year}0131`, "YYYYMMDD")
        .week(weekNumber)
        .startOf("week")
        .toDate()
    ).month();
    return month + 1;
  }
}
export default HighlightWeek;

